import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";
import { cn } from "../lib/utils";

export function DataTable({ columns, data, onRowClick, emptyState, className }) {
  return (
    <div className={cn("rounded-md border bg-card", className)}>
      <Table>
        <TableHeader className="sticky top-0 bg-card z-10">
          <TableRow>
            {columns.map((col, index) => (
              <TableHead 
                key={col.key || index} 
                className={col.className}
                style={{ textAlign: col.align || "left" }}
              >
                {col.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data.length > 0 ? (
            data.map((row, rowIndex) => (
              <TableRow 
                key={rowIndex}
                className={cn(onRowClick && "cursor-pointer")}
                onClick={() => onRowClick && onRowClick(row)}
              >
                {columns.map((col, colIndex) => (
                  <TableCell 
                    key={col.key || colIndex}
                    className={col.className}
                    style={{ textAlign: col.align || "left" }}
                  >
                    {col.render ? col.render(row) : row[col.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell 
                colSpan={columns.length} 
                className="h-24 text-center text-muted-foreground"
              >
                {emptyState || "Nenhum registro encontrado."}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
